import Quill from 'quill';

class ImageMenu {
  quill: Quill;
  onImageSelect: (image: { element: HTMLElement; isFirstChild: boolean } | null) => void;

  constructor(
    quill: Quill,
    options: { onImageSelect: (image: { element: HTMLElement; isFirstChild: boolean } | null) => void },
  ) {
    this.quill = quill;
    this.onImageSelect = options.onImageSelect;

    this.quill.root.addEventListener('click', this.handleMouseClick);
  }

  handleMouseClick = (event: Event) => {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const paragraph = target.closest('p');
    if (!paragraph) return;

    const images = Array.from(paragraph.querySelectorAll('img'));
    if (images.length === 0) {
      this.onImageSelect(null);
      return;
    }

    if (target.tagName === 'IMG') {
      const isFirstChild = target === images[0];
      this.onImageSelect({ element: target as HTMLImageElement, isFirstChild });
    } else {
      this.onImageSelect(null);
    }
  };
  destroy() {
    this.quill.root.removeEventListener('click', this.handleMouseClick);
  }
}
Quill.register('modules/imageMenu', ImageMenu);

export default ImageMenu;
